import React, { useState, useCallback } from "react";
import { BASE_URL, USER_URL } from "../../../constant/api";
import { Link } from "react-router-dom";
import { RiDeleteBin6Line } from "react-icons/ri";
import axios from "axios";
import { IoCloseSharp } from "react-icons/io5";
import AddToCartModel from "../AddToCartModel/AddToCartModel";

function WishlistCard({ product, row, col, setWishlist }) {
    const colors = ["bg-[#B6EBB5]", "bg-white"];
    const backgroundColor = colors[(row + col) % 2];
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [quantity, setQuantity] = useState(1);

    // Open Modal
    const openModal = useCallback((product) => {
        setSelectedProduct(product);
        setIsModalOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsModalOpen(false);
        setSelectedProduct(null);
    }, []);

    // Delete wishlist item and update UI
    const handleDeleteWishlistItem = async (productId) => {
        const token = localStorage.getItem("token");
        const sessionId = localStorage.getItem("sessionid");

        const headers = token
            ? { Authorization: `Token ${token}` }
            : { "Session-Id": sessionId };

        try {
            const response = await USER_URL.delete(
                `/products/wishlist/${productId}/`,
            );

            if (response.status === 200 && response.data.Status === "1") {
                if (setWishlist) {
                    setWishlist((prev) =>
                        prev.filter((item) => item.product_id !== productId)
                    );
                }
                console.log("Item deleted successfully:", response.data);
            } else {
                console.error("Unexpected response:", response.data);
            }
        } catch (error) {
            console.error(`Error deleting item ${productId}:`, error);
        }
    };


    return (
        <div className={`relative ${backgroundColor} w-full h-36 rounded-lg border-2 p-4 shadow-lg flex items-center gap-4`}>
            {/* Delete Icon */}
            <RiDeleteBin6Line
                className="absolute top-2 right-2 text-gray-500 hover:text-red-500 cursor-pointer text-xl"
                onClick={() => handleDeleteWishlistItem(product.product_id)}
            />

            {/* Product Image */}
            <div className="w-28 h-28 flex-shrink-0">
                <Link to={`/product-details/${product.product_id}`}>
                    <img
                        src={
                            product.product_images
                                ? product.product_images.startsWith(BASE_URL)
                                    ? product.product_images
                                    : `${BASE_URL}${product.product_images}`
                                : "/images/default-product.png"
                        }
                        alt={product.product_name || "Product"}
                        className="object-contain w-full h-full rounded-lg"
                        onError={(e) => {
                            e.target.src = "/images/default-product.png";
                        }}
                    />
                </Link>
            </div>

            {/* Product Info */}
            <div className="flex-1">
                <h3 className="text-sm md:text-lg font-semibold text-gray-800 line-clamp-1">
                    { product.product_name || "No Product Name available."}
                    </h3>
                <p className="text-xs md:text-sm text-gray-500 line-clamp-2">
                    {product.description || "No description available."}
                </p>
                <div className="flex flex-wrap justify-between items-center mt-2">
                    {/* Price and Discount */}
                    <div className="flex items-center gap-2">
                        <p className="text-sm md:text-base text-gray-800 font-semibold">{product.currency_symbol}{product.price_per_item}</p>
                        <p className="text-xs md:text-sm text-red-500 font-semibold">-{product.offer_percent}%</p>
                    </div>
                    {/* Move to Cart Button */}
                    <button
                        onClick={() => openModal(product)}
                        className="bg-brand-primary text-xs text-white py-2 px-4 rounded-md hover:bg-[#00a650d3]"
                    >
                        Move to cart
                    </button>
                </div>
            </div>

            <AddToCartModel
        selectedProduct={selectedProduct}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
      />
        </div>
    );
}

export default WishlistCard;
